module.exports = __webpack_public_path__ + "static/media/icon_alert_error_24px.45927e9a.svg";